import React from 'react';
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore';
import { store } from '../../stores/store';
import './NewGameAlertPopup.css';


const NewGameAlertPopup = () => {


  return (
    <div className="overlay">

      <div className="NewGameAlertPopup">
        <h3 dangerouslySetInnerHTML={{__html: store.t("new_game_alert_popup_title")}} />
        <div className="NewGameAlertPopup-content">
          <p dangerouslySetInnerHTML={{__html:  store.t("new_game_alert_popup_content")}} />
          <div className="new_game_alert_popup_btns">
            <button onClick={() => store.restartGame()} dangerouslySetInnerHTML={{__html: store.t("yes")}} />
            <button onClick={() => PopupStore.close(POPUPS_IDS.NEW_GAME_ALERT)} dangerouslySetInnerHTML={{__html: store.t("no")}} />
          </div>
        </div>
      </div>

    </div>
  )
}

export default NewGameAlertPopup;
